// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subModalBackdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 0.75;
}

.subModalOpen {
  overflow: hidden !important;
}
.subModalOpen .subModal {
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.subModal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}
.subModal .subModalDocument {
  max-width: 1140px;
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.subModal .subModalHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.subModal .subModalDialog {
  margin: 1.75rem;
  transform: none;
  transition: transform 0.3s ease-out;
  position: relative;
  width: auto;
  pointer-events: none;
}
.subModal .subModalContent {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0;
  outline: 0;
}
.subModal .subModalFooter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.subModal .subModalBody {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
  overflow: hidden auto;
  height: 720px;
}
.subModal .subModalContent {
  overflow: hidden;
  overflow: auto;
}

.modal-drawer {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.75);
  display: none;
}
.modal-drawer.show {
  display: flex;
}
.modal-drawer.show + body {
  overflow: hidden;
}
.modal-drawer .drawer-modal {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 768px;
  max-width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 0;
  outline: 0;
  right: 0;
  overflow: auto;
  position: fixed;
  padding: 10px;
  opacity: 1;
  z-index: 1050;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.25);
  transition: all 0.3s ease-in-out;
  animation: tamanho 0.3s ease-in-out;
}
.modal-drawer .drawer-modal form {
  display: contents;
}

@keyframes tamanho {
  to {
    width: 768px;
  }
  from {
    width: 0px;
  }
}
body {
  transition: all 0.6s ease-in-out;
  animation: opacidade 0.6s;
}
body.background-metropolitano-azul-real {
  background-color: #13172b;
}
body.background-metropolitano-roxo-real {
  background-color: #62628e;
}
body.background-metropolitano-purple-real {
  background-color: #3b3b88;
}
body.background-metropolitano-green-real {
  background-color: #609f36;
}
body.background-metropolitano-black-real {
  background-color: #000000;
}
body.background-metropolitano-image-1 {
  background-image: url("/assets/images/temas/tema-background-1.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}
body.background-metropolitano-image-2 {
  background-image: url("/assets/images/temas/tema-background-2.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}
body.background-metropolitano-image-3 {
  background-image: url("/assets/images/temas/tema-background-3.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}
body.background-metropolitano-image-4 {
  background-image: url("/assets/images/temas/tema-background-4.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}

@keyframes opacidade {
  0% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}
.btn-primary-soft {
  color: #222b54;
  background-color: rgba(34, 43, 84, 0.3);
}
.btn-primary-soft:hover {
  color: #f4f7fe;
  background-color: #222b54;
}

.btn-secondary-soft {
  color: #5143d9;
  background-color: rgba(81, 67, 217, 0.1);
}
.btn-secondary-soft:hover {
  color: #f4f7fe;
  background-color: #5143d9;
}

.w-10 {
  height: 2.5rem;
}

.h-10 {
  height: 2.5rem;
}

.custom-file-label::after {
  content: "Procurar" !important;
}

.bg-gradient {
  background: linear-gradient(178.18deg, #222b54 44.62%, #9ad1e5 158.3%);
  color: #fff !important;
}

.bg-gradient-green {
  background: linear-gradient(178.18deg, #28a745 44.62%, #9ad1e5 158.3%);
  color: #fff !important;
}

.border-radius-215 {
  border-radius: 215px;
}

.modal-extra {
  max-width: 1900px;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-no-drop {
  cursor: no-drop !important;
}

.text-underline-hover:hover {
  -webkit-text-decoration: 1px solid #222b54;
          text-decoration: 1px solid #222b54;
}

.circle {
  border-radius: 95px !important;
}

.font-raleway {
  font-family: "Raleway", sans-serif !important;
}

.font-weight-100 {
  font-weight: 100 !important;
}

.font-weight-200 {
  font-weight: 200 !important;
}

.font-weight-300 {
  font-weight: 300 !important;
}

.font-weight-400 {
  font-weight: 400 !important;
}

.font-weight-500 {
  font-weight: 500 !important;
}

.font-weight-600 {
  font-weight: 600 !important;
}

.font-weight-700 {
  font-weight: 700 !important;
}

.font-weight-800 {
  font-weight: 800 !important;
}

.font-weight-900 {
  font-weight: 900 !important;
}

.border-radius-10 {
  border-radius: 10 !important;
}

.border-radius-20 {
  border-radius: 20 !important;
}

.border-radius-30 {
  border-radius: 30 !important;
}

.border-radius-40 {
  border-radius: 40 !important;
}

.border-radius-50 {
  border-radius: 50 !important;
}

.border-radius-60 {
  border-radius: 60 !important;
}

.border-radius-70 {
  border-radius: 70 !important;
}

.border-radius-80 {
  border-radius: 80 !important;
}

.border-radius-90 {
  border-radius: 90 !important;
}

.list-style-none {
  list-style: none !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.bg-inherit {
  background: inherit !important;
}

.linha-carrega-mais {
  position: relative;
  list-style: none;
}
.linha-carrega-mais li {
  text-align: center;
  background: #e8e4e4;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
}
.linha-carrega-mais li span {
  background: inherit;
  z-index: 2;
  padding-right: 10px;
  padding-left: 10px;
  position: absolute;
  top: 0;
  cursor: pointer;
  margin: 0 -15px;
}
.linha-carrega-mais li span:hover {
  border-bottom: #222b54 solid 1px;
  color: #222b54;
}
.linha-carrega-mais li:after {
  content: "";
  width: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.1);
  height: 1px;
  right: 0;
  top: 13px;
  z-index: 1;
}

ngb-tabset .tabset,
ngb-tabset .tab-content,
ngb-tabset .tab-pane,
ngb-tabset .tabbable {
  height: 100% !important;
}

.white-space-nowrap {
  white-space: nowrap !important;
}

.subModalOpen {
  overflow: hidden !important;
}
.subModalOpen .subModal {
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.align-middle {
  vertical-align: middle !important;
}

.form-floating {
  position: relative;
  padding-top: 12px;
  width: 100%;
}
.form-floating label {
  pointer-events: none;
  position: absolute;
  top: calc(60% - 8px);
  left: 8px;
  transition: all 0.1s linear;
  -webkit-transition: all 0.1s linear;
  -moz-transition: all 0.1s linear;
  padding: 0rem 0.2rem;
  box-sizing: border-box;
  font-size: 12px;
  white-space: nowrap;
}
.form-floating input {
  color: #222b54;
  border: 1px solid lightgrey;
  border-radius: 5px;
  outline: none;
  width: 100%;
  height: 2.8rem;
  padding: 1.375rem 0.75rem 0.75rem 0.75rem;
  font-size: 16px;
  transition: all 0.1s linear;
  -webkit-transition: all 0.1s linear;
  -moz-transition: all 0.1s linear;
  -webkit-appearance: none;
}
.form-floating input:focus {
  border: 1px solid #222b54;
}
.form-floating input:focus + label {
  font-size: 10px;
  top: 12px;
  color: #2e6fea;
}
.form-floating input::placeholder {
  color: transparent;
}
.form-floating input:required:invalid {
  border: 1px solid #ff4949;
}
.form-floating input:required:invalid + label {
  color: #ff4949;
}
.form-floating input:required:invalid + label:before {
  content: "* ";
}
.form-floating input:not(:placeholder-shown) + label {
  font-size: 10px;
  top: 12px;
  color: #2e6fea;
}

.mobile-opcoes {
  display: none;
}

:host ::ng-deep .popover {
  max-width: -moz-fit-content;
  max-width: fit-content;
}
:host ::ng-deep .popover .arrow::after {
  border-bottom-color: #b6bec8;
}
:host ::ng-deep .popover .popover-header {
  background-color: #222b54;
  padding: 0.5rem 0.75rem;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
}
:host ::ng-deep .popover .popover-header::before {
  border-bottom: none;
}
:host ::ng-deep .popover .popover-body {
  padding: 0;
}
:host ::ng-deep .popover .popover-body button:hover {
  background-color: #222b54;
  color: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/themes/_sub-modal.scss","webpack://./src/app/core/shared/components/modais/impressao/impressao.component.scss","webpack://./src/themes/_backgrounds-condominioapp.scss","webpack://./src/themes/styles-var.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;ACCF;;ADCA;EAEE,2BAAA;ACCF;ADCE;EACE,6BAAA;EACA,2BAAA;ACCJ;;ADGA;EASE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;ACRF;ADSE;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;ACPJ;ADSE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,yBAAA;EACA,0BAAA;ACPJ;ADSE;EAEE,eAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;ACRJ;ADUE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;EACA,oCAAA;EACA,gBAAA;EACA,UAAA;ACRJ;ADWE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;ACTJ;ADWE;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,aAAA;ACTJ;ADWE;EACE,gBAAA;EACA,cAAA;ACTJ;;ADeA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,2CAAA;EACA,aAAA;ACZF;ADaE;EACE,aAAA;ACXJ;ADYI;EACE,gBAAA;ACVN;ADaE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;EACA,4BAAA;EACA,gBAAA;EACA,UAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;EACA,8CAAA;EACA,gCAAA;EACA,mCAAA;ACXJ;ADYI;EACE,iBAAA;ACVN;;ADeA;EACE;IACE,YAAA;ECZF;EDcA;IACE,UAAA;ECZF;AACF;ACvIA;EACE,gCAAA;EACA,yBAAA;ADyIF;ACxIE;EACE,yBAAA;AD0IJ;ACxIE;EACE,yBAAA;AD0IJ;ACxIE;EACE,yBAAA;AD0IJ;ACxIE;EACE,yBAAA;AD0IJ;ACxIE;EACE,yBAAA;AD0IJ;ACvIE;EACE,mEAAA;EACA,sBAAA;EACA,4BAAA;ADyIJ;ACvIE;EACE,mEAAA;EACA,sBAAA;EACA,4BAAA;ADyIJ;ACvIE;EACE,mEAAA;EACA,sBAAA;EACA,4BAAA;ADyIJ;ACvIE;EACE,mEAAA;EACA,sBAAA;EACA,4BAAA;ADyIJ;;ACrIA;EACE;IACE,YAAA;EDwIF;ECrIA;IACE,YAAA;EDuIF;ECpIA;IACE,UAAA;EDsIF;AACF;AErHA;EACE,cAAA;EACA,uCAAA;AFuHF;AErHE;EACE,cAAA;EACA,yBAAA;AFuHJ;;AEnHA;EACE,cAAA;EACA,wCAAA;AFsHF;AEpHE;EACE,cAAA;EACA,yBAAA;AFsHJ;;AElHA;EACE,cAAA;AFqHF;;AEhHA;EACE,cAAA;AFmHF;;AE4CA;EACE,8BAAA;AFzCF;;AE8CA;EACE,sEAAA;EACA,sBAAA;AF3CF;;AE8CA;EACE,sEAAA;EACA,sBAAA;AF3CF;;AE8CA;EACE,oBAAA;AF3CF;;AE8CA;EACE,iBAAA;AF3CF;;AE8CA;EACE,0BAAA;AF3CF;;AE8CA;EACE,0BAAA;AF3CF;;AE+CE;EACE,0CAAA;UAAA,kCAAA;AF5CJ;;AEgDA;EACE,8BAAA;AF7CF;;AEgDA;EACE,6CAAA;AF7CF;;AEiDE;EACE,2BAAA;AF9CJ;;AE6CE;EACE,2BAAA;AF1CJ;;AEyCE;EACE,2BAAA;AFtCJ;;AEqCE;EACE,2BAAA;AFlCJ;;AEiCE;EACE,2BAAA;AF9BJ;;AE6BE;EACE,2BAAA;AF1BJ;;AEyBE;EACE,2BAAA;AFtBJ;;AEqBE;EACE,2BAAA;AFlBJ;;AEiBE;EACE,2BAAA;AFdJ;;AEmBE;EACE,4BAAA;AFhBJ;;AEeE;EACE,4BAAA;AFZJ;;AEWE;EACE,4BAAA;AFRJ;;AEOE;EACE,4BAAA;AFJJ;;AEGE;EACE,4BAAA;AFAJ;;AEDE;EACE,4BAAA;AFIJ;;AELE;EACE,4BAAA;AFQJ;;AETE;EACE,4BAAA;AFYJ;;AEbE;EACE,4BAAA;AFgBJ;;AEZA;EACE,2BAAA;AFeF;;AEZA;EACE,2BAAA;AFeF;;AEZA;EACE,2BAAA;AFeF;;AEZA;EACE,8BAAA;AFeF;;AEZA;EACE,kBAAA;EACA,gBAAA;AFeF;AEbE;EACE,kBAAA;EACA,mBAnTQ;EAoTR,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AFeJ;AEbI;EACE,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,eAAA;AFeN;AEbM;EACE,gCAAA;EACA,cA/VE;AF8WV;AEXI;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AFaN;;AENE;;;;EAIE,uBAAA;AFSJ;;AELA;EACE,8BAAA;AFQF;;AELA;EAEE,2BAAA;AFOF;AELE;EACE,6BAAA;EACA,2BAAA;AFOJ;;AEHA;EACE,iCAAA;AFMF;;AEHA;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;AFMF;AEJE;EACE,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,SAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,oBAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;AFMJ;AEHE;EACE,cAhaM;EAiaN,2BAAA;EACA,kBAAA;EACA,aAAA;EAEA,WAAA;EACA,cAAA;EACA,yCAAA;EACA,eAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,wBAAA;AFIJ;AEFI;EACE,yBAAA;AFIN;AEFM;EACE,eAAA;EACA,SAAA;EACA,cAAA;AFIR;AEAI;EACE,kBAAA;AFEN;AEEM;EACE,yBAAA;AFAR;AEEQ;EACE,cA1bF;AF0bR;AEEU;EACE,aAAA;AFAZ;AEOM;EACE,eAAA;EACA,SAAA;EACA,cAAA;AFLR;;AEWA;EACE,aAAA;AFRF;;AEWA;EACE,2BAAA;EAAA,sBAAA;AFRF;AEYI;EACE,4BAhcO;AFsbb;AEcE;EACE,yBAneM;EAoeN,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AFZJ;AEcI;EACE,mBAAA;AFZN;AEgBE;EACE,UAAA;AFdJ;AEiBM;EACE,yBArfE;EAsfF,sBAAA;AFfR","sourcesContent":[".subModalBackdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n  opacity: 0.75;\n}\n.subModalOpen {\n  // Kill the scroll on the body\n  overflow: hidden !important;\n\n  .subModal {\n    overflow-x: hidden !important;\n    overflow-y: auto !important;\n  }\n}\n\n.subModal {\n  // position: fixed;\n  // top: 2vh;\n  // height: 90vh;\n  // z-index: 1050;\n  // width: 96vw;\n  // left: 2vw;\n  // border: solid #555 2px;\n  // border-radius: 4px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  outline: 0;\n  .subModalDocument {\n    max-width: 1140px;\n    position: relative;\n    width: auto;\n    margin: 0.5rem;\n    pointer-events: none;\n  }\n  .subModalHeader {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    padding: 1rem 1rem;\n    border-bottom: 1px solid #dee2e6;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .subModalDialog {\n    // margin: 1.75rem auto;\n    margin: 1.75rem;\n    transform: none;\n    transition: transform 0.3s ease-out;\n    position: relative;\n    width: auto;\n    pointer-events: none;\n  }\n  .subModalContent {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    pointer-events: auto;\n    background-color: #ffffff;\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-radius: 0;\n    outline: 0;\n  }\n\n  .subModalFooter {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 1rem;\n    border-top: 1px solid #dee2e6;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .subModalBody {\n    position: relative;\n    flex: 1 1 auto;\n    padding: 1rem;\n    overflow: hidden auto;\n    height: 720px;\n  }\n  .subModalContent {\n    overflow: hidden;\n    overflow: auto;\n  }\n}\n\n\n\n.modal-drawer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(255, 255, 255, 0.75);\n  display: none;\n  &.show {\n    display: flex;\n    + body {\n      overflow: hidden;\n    }\n  }\n  .drawer-modal {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 768px;\n    max-width: 100%;\n    pointer-events: auto;\n    background-color: #fff;\n    background-clip: padding-box;\n    border-radius: 0;\n    outline: 0;\n    right: 0;\n    overflow: auto;\n    position: fixed;\n    padding: 10px;\n    opacity: 1;\n    z-index: 1050;\n    box-shadow: 0 0 10px rgba(255, 255, 255, 0.25);\n    transition: all 0.3s ease-in-out;\n    animation: tamanho 0.3s ease-in-out;\n    form {\n      display: contents;\n    }\n  }\n}\n\n@keyframes tamanho {\n  to {\n    width: 768px;\n  }\n  from {\n    width: 0px;\n  }\n}\n",".subModalBackdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n  opacity: 0.75;\n}\n\n.subModalOpen {\n  overflow: hidden !important;\n}\n.subModalOpen .subModal {\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n}\n\n.subModal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  outline: 0;\n}\n.subModal .subModalDocument {\n  max-width: 1140px;\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none;\n}\n.subModal .subModalHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n  border-bottom: 1px solid #dee2e6;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.subModal .subModalDialog {\n  margin: 1.75rem;\n  transform: none;\n  transition: transform 0.3s ease-out;\n  position: relative;\n  width: auto;\n  pointer-events: none;\n}\n.subModal .subModalContent {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0;\n  outline: 0;\n}\n.subModal .subModalFooter {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 1rem;\n  border-top: 1px solid #dee2e6;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.subModal .subModalBody {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 1rem;\n  overflow: hidden auto;\n  height: 720px;\n}\n.subModal .subModalContent {\n  overflow: hidden;\n  overflow: auto;\n}\n\n.modal-drawer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(255, 255, 255, 0.75);\n  display: none;\n}\n.modal-drawer.show {\n  display: flex;\n}\n.modal-drawer.show + body {\n  overflow: hidden;\n}\n.modal-drawer .drawer-modal {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 768px;\n  max-width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 0;\n  outline: 0;\n  right: 0;\n  overflow: auto;\n  position: fixed;\n  padding: 10px;\n  opacity: 1;\n  z-index: 1050;\n  box-shadow: 0 0 10px rgba(255, 255, 255, 0.25);\n  transition: all 0.3s ease-in-out;\n  animation: tamanho 0.3s ease-in-out;\n}\n.modal-drawer .drawer-modal form {\n  display: contents;\n}\n\n@keyframes tamanho {\n  to {\n    width: 768px;\n  }\n  from {\n    width: 0px;\n  }\n}\nbody {\n  transition: all 0.6s ease-in-out;\n  animation: opacidade 0.6s;\n}\nbody.background-metropolitano-azul-real {\n  background-color: #13172b;\n}\nbody.background-metropolitano-roxo-real {\n  background-color: #62628e;\n}\nbody.background-metropolitano-purple-real {\n  background-color: #3b3b88;\n}\nbody.background-metropolitano-green-real {\n  background-color: #609f36;\n}\nbody.background-metropolitano-black-real {\n  background-color: #000000;\n}\nbody.background-metropolitano-image-1 {\n  background-image: url(\"/assets/images/temas/tema-background-1.jpg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n}\nbody.background-metropolitano-image-2 {\n  background-image: url(\"/assets/images/temas/tema-background-2.jpg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n}\nbody.background-metropolitano-image-3 {\n  background-image: url(\"/assets/images/temas/tema-background-3.jpg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n}\nbody.background-metropolitano-image-4 {\n  background-image: url(\"/assets/images/temas/tema-background-4.jpg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n@keyframes opacidade {\n  0% {\n    opacity: 0.4;\n  }\n  50% {\n    opacity: 0.6;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.btn-primary-soft {\n  color: #222b54;\n  background-color: rgba(34, 43, 84, 0.3);\n}\n.btn-primary-soft:hover {\n  color: #f4f7fe;\n  background-color: #222b54;\n}\n\n.btn-secondary-soft {\n  color: #5143d9;\n  background-color: rgba(81, 67, 217, 0.1);\n}\n.btn-secondary-soft:hover {\n  color: #f4f7fe;\n  background-color: #5143d9;\n}\n\n.w-10 {\n  height: 2.5rem;\n}\n\n.h-10 {\n  height: 2.5rem;\n}\n\n.custom-file-label::after {\n  content: \"Procurar\" !important;\n}\n\n.bg-gradient {\n  background: linear-gradient(178.18deg, #222b54 44.62%, #9ad1e5 158.3%);\n  color: #fff !important;\n}\n\n.bg-gradient-green {\n  background: linear-gradient(178.18deg, #28a745 44.62%, #9ad1e5 158.3%);\n  color: #fff !important;\n}\n\n.border-radius-215 {\n  border-radius: 215px;\n}\n\n.modal-extra {\n  max-width: 1900px;\n}\n\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n.cursor-no-drop {\n  cursor: no-drop !important;\n}\n\n.text-underline-hover:hover {\n  text-decoration: 1px solid #222b54;\n}\n\n.circle {\n  border-radius: 95px !important;\n}\n\n.font-raleway {\n  font-family: \"Raleway\", sans-serif !important;\n}\n\n.font-weight-100 {\n  font-weight: 100 !important;\n}\n\n.font-weight-200 {\n  font-weight: 200 !important;\n}\n\n.font-weight-300 {\n  font-weight: 300 !important;\n}\n\n.font-weight-400 {\n  font-weight: 400 !important;\n}\n\n.font-weight-500 {\n  font-weight: 500 !important;\n}\n\n.font-weight-600 {\n  font-weight: 600 !important;\n}\n\n.font-weight-700 {\n  font-weight: 700 !important;\n}\n\n.font-weight-800 {\n  font-weight: 800 !important;\n}\n\n.font-weight-900 {\n  font-weight: 900 !important;\n}\n\n.border-radius-10 {\n  border-radius: 10 !important;\n}\n\n.border-radius-20 {\n  border-radius: 20 !important;\n}\n\n.border-radius-30 {\n  border-radius: 30 !important;\n}\n\n.border-radius-40 {\n  border-radius: 40 !important;\n}\n\n.border-radius-50 {\n  border-radius: 50 !important;\n}\n\n.border-radius-60 {\n  border-radius: 60 !important;\n}\n\n.border-radius-70 {\n  border-radius: 70 !important;\n}\n\n.border-radius-80 {\n  border-radius: 80 !important;\n}\n\n.border-radius-90 {\n  border-radius: 90 !important;\n}\n\n.list-style-none {\n  list-style: none !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.bg-inherit {\n  background: inherit !important;\n}\n\n.linha-carrega-mais {\n  position: relative;\n  list-style: none;\n}\n.linha-carrega-mais li {\n  text-align: center;\n  background: #e8e4e4;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 1rem;\n}\n.linha-carrega-mais li span {\n  background: inherit;\n  z-index: 2;\n  padding-right: 10px;\n  padding-left: 10px;\n  position: absolute;\n  top: 0;\n  cursor: pointer;\n  margin: 0 -15px;\n}\n.linha-carrega-mais li span:hover {\n  border-bottom: #222b54 solid 1px;\n  color: #222b54;\n}\n.linha-carrega-mais li:after {\n  content: \"\";\n  width: 100%;\n  position: absolute;\n  background: rgba(0, 0, 0, 0.1);\n  height: 1px;\n  right: 0;\n  top: 13px;\n  z-index: 1;\n}\n\nngb-tabset .tabset,\nngb-tabset .tab-content,\nngb-tabset .tab-pane,\nngb-tabset .tabbable {\n  height: 100% !important;\n}\n\n.white-space-nowrap {\n  white-space: nowrap !important;\n}\n\n.subModalOpen {\n  overflow: hidden !important;\n}\n.subModalOpen .subModal {\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.form-floating {\n  position: relative;\n  padding-top: 12px;\n  width: 100%;\n}\n.form-floating label {\n  pointer-events: none;\n  position: absolute;\n  top: calc(60% - 8px);\n  left: 8px;\n  transition: all 0.1s linear;\n  -webkit-transition: all 0.1s linear;\n  -moz-transition: all 0.1s linear;\n  padding: 0rem 0.2rem;\n  box-sizing: border-box;\n  font-size: 12px;\n  white-space: nowrap;\n}\n.form-floating input {\n  color: #222b54;\n  border: 1px solid lightgrey;\n  border-radius: 5px;\n  outline: none;\n  width: 100%;\n  height: 2.8rem;\n  padding: 1.375rem 0.75rem 0.75rem 0.75rem;\n  font-size: 16px;\n  transition: all 0.1s linear;\n  -webkit-transition: all 0.1s linear;\n  -moz-transition: all 0.1s linear;\n  -webkit-appearance: none;\n}\n.form-floating input:focus {\n  border: 1px solid #222b54;\n}\n.form-floating input:focus + label {\n  font-size: 10px;\n  top: 12px;\n  color: #2e6fea;\n}\n.form-floating input::placeholder {\n  color: transparent;\n}\n.form-floating input:required:invalid {\n  border: 1px solid #ff4949;\n}\n.form-floating input:required:invalid + label {\n  color: #ff4949;\n}\n.form-floating input:required:invalid + label:before {\n  content: \"* \";\n}\n.form-floating input:not(:placeholder-shown) + label {\n  font-size: 10px;\n  top: 12px;\n  color: #2e6fea;\n}\n\n.mobile-opcoes {\n  display: none;\n}\n\n:host ::ng-deep .popover {\n  max-width: fit-content;\n}\n:host ::ng-deep .popover .arrow::after {\n  border-bottom-color: #b6bec8;\n}\n:host ::ng-deep .popover .popover-header {\n  background-color: #222b54;\n  padding: 0.5rem 0.75rem;\n  color: #fff;\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 14px;\n}\n:host ::ng-deep .popover .popover-header::before {\n  border-bottom: none;\n}\n:host ::ng-deep .popover .popover-body {\n  padding: 0;\n}\n:host ::ng-deep .popover .popover-body button:hover {\n  background-color: #222b54;\n  color: #fff !important;\n}","body {\n  transition: all 0.6s ease-in-out;\n  animation: opacidade 0.6s;\n  &.background-metropolitano-azul-real {\n    background-color: #13172b;\n  }\n  &.background-metropolitano-roxo-real {\n    background-color: #62628e;\n  }\n  &.background-metropolitano-purple-real {\n    background-color: #3b3b88;\n  }\n  &.background-metropolitano-green-real {\n    background-color: #609f36;\n  }\n  &.background-metropolitano-black-real {\n    background-color: #000000;\n  }\n\n  &.background-metropolitano-image-1 {\n    background-image: url(\"/assets/images/temas/tema-background-1.jpg\");\n    background-size: cover;\n    background-repeat: no-repeat;\n  }\n  &.background-metropolitano-image-2 {\n    background-image: url(\"/assets/images/temas/tema-background-2.jpg\");\n    background-size: cover;\n    background-repeat: no-repeat;\n  }\n  &.background-metropolitano-image-3 {\n    background-image: url(\"/assets/images/temas/tema-background-3.jpg\");\n    background-size: cover;\n    background-repeat: no-repeat;\n  }\n  &.background-metropolitano-image-4 {\n    background-image: url(\"/assets/images/temas/tema-background-4.jpg\");\n    background-size: cover;\n    background-repeat: no-repeat;\n  }\n}\n\n@keyframes opacidade {\n  0% {\n    opacity: 0.4;\n  }\n\n  50% {\n    opacity: 0.6;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n","@import \"fonts/variables.scss\";\n\n$primary: #222b54;\n$secundary: #4F65AD;\n$tertiary: #cae4eb;\n$title: #314257;\n$text: #c4c4c4;\n$green: #28a745;\n$success: #04aa6d;\n$error: #ff4949;\n$danger: #d22630;\n$attention: #fec051;\n$form-label: #323c47;\n$form-label2: #323c22;\n\n// backgrounds\n$fundo: #13172b;\n$fundo1: #62628e;\n$fundo2: #7b7bf2;\n$fundo3: $success;\n$fundo4: #c3c3c3;\n\n// box shadow\n$boxShadow: rgba(0, 0, 0, 0.5) 1px 1px 10px, rgba(0, 0, 0, 0.5) 1px 1px 10px;\n\n// tons de gray\n$gray: #656565;\n$grayDark: #323c47;\n$grayLight: #e8e4e4;\n$grayLight1: #f5f5f5;\n$grayLight2: #f8f5f1;\n$grayLight3: #bfcdd5;\n$grayLight4: #b6bec8;\n$grayLight5: #4b4b4b;\n$grayLight6: #e9eff4;\n$grayLight7: #595d66;\n$grayLight8: #d1d1d1;\n\n$theme-colors: (\n  \"primary\": $primary,\n  \"secundary\": $secundary,\n  \"tertiary\": $tertiary,\n  \"title\": $title,\n  \"text\": $text,\n  \"danger\": $danger,\n  \"success\": $success,\n  \"green\": $green,\n  \"error\": $error,\n  \"attention\": $attention,\n  \"form-label\": $form-label,\n  \"gray\": $gray,\n  \"gray-dark\": $grayDark,\n  \"gray-light\": $grayLight,\n  \"gray-light-1\": $grayLight1,\n  \"gray-light-2\": $grayLight2,\n  \"gray-light-3\": $grayLight3,\n  \"gray-light-4\": $grayLight4,\n  \"gray-light-5\": $grayLight5,\n  \"gray-light-6\": $grayLight6,\n  \"gray-light-7\": $grayLight7,\n  \"gray-light-8\": $grayLight8,\n);\n\n$font-family-base: Ubuntu, Poppins, Roboto, Arial, \"Arial Unicode MS\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n  \"Helvetica Neue\", \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\",\n  \"Noto Color Emoji\";\n$font-sizes: 8, 10, 12, 14, 15, 16, 18, 20, 22, 24, 28, 32, 36, 48, 64, 72 !default;\n\n\n.btn-primary-soft {\n  color: #222b54;\n  background-color: rgba(34, 43, 84, 0.3);\n\n  &:hover {\n    color: #f4f7fe;\n    background-color: #222b54;\n  }\n}\n\n.btn-secondary-soft {\n  color: #5143d9;\n  background-color: rgba(81, 67, 217, 0.1);\n\n  &:hover {\n    color: #f4f7fe;\n    background-color: #5143d9;\n  }\n}\n\n.w-10 {\n  height: 2.5rem\n    /* 40px */\n  ;\n}\n\n.h-10 {\n  height: 2.5rem\n    /* 40px */\n  ;\n}\n\n$spacer: 1rem;\n\n$spacers: (\n  0: 0,\n  1: ($spacer * 0.25),\n  2: ($spacer * 0.5),\n  3: ($spacer * 0.75),\n  4: ($spacer * 1),\n  5: ($spacer * 1.25),\n  6: ($spacer * 1.5),\n  7: ($spacer * 1.75),\n  8: ($spacer * 2),\n  9: ($spacer * 2.25),\n  10: ($spacer * 2.5),\n  11: ($spacer * 2.75),\n  12: ($spacer * 3),\n  13: ($spacer * 3.25),\n  14: ($spacer * 3.5),\n  15: ($spacer * 3.75),\n  16: ($spacer * 4),\n  17: ($spacer * 4.25),\n  18: ($spacer * 4.5),\n  19: ($spacer * 4.75),\n  20: ($spacer * 5),\n  21: ($spacer * 5.25),\n  24: ($spacer * 6),\n  28: ($spacer * 7),\n  32: ($spacer * 8),\n  36: ($spacer * 9),\n  40: ($spacer * 10),\n  44: ($spacer * 11),\n  48: ($spacer * 12),\n  52: ($spacer * 13),\n  56: ($spacer * 14),\n  60: ($spacer * 15),\n  64: ($spacer * 16),\n  72: ($spacer * 18),\n  80: ($spacer * 20),\n  96: ($spacer * 24)\n);\n\n$font-sizes: (\n  1: $h1-font-size,\n  // 22.75px\n  2: $h2-font-size,\n  // 19.50px\n  3: $h3-font-size,\n  // 17.55px\n  4: $h4-font-size,\n  // 16.25px\n  5: $h5-font-size,\n  // 14.95px\n  6: $h6-font-size,\n\n  // 13.95px\n  7: $font-size-base * 0.95,\n  // 12.35px\n  8: $font-size-base * 0.85,\n  // 11.05px\n  9: $font-size-base * 0.75,\n  // 9.75px\n  10: $font-size-base * 0.5,\n\n  // 6.50px\n  base: $font-size-base,\n  // 13px\n  fluid: 100%,\n\n  // 100%\n  2x: $font-size-base * 2,\n  // 26px\n  2qx: $font-size-base * 2.25,\n  // 29.25px\n  2hx: $font-size-base * 2.5,\n  // 32.5px\n  2tx: $font-size-base * 2.75,\n\n  // 35.75px\n  3x: $font-size-base * 3,\n  // 39px\n  3qx: $font-size-base * 3.25,\n  // 42.25px\n  3hx: $font-size-base * 3.5,\n  // 45.5px\n  3tx: $font-size-base * 3.75,\n\n  // 48.75px\n  4x: $font-size-base * 4,\n  // 52px\n  4qx: $font-size-base * 4.25,\n  // 55.25px\n  4hx: $font-size-base * 4.5,\n  // 58.5px\n  4tx: $font-size-base * 4.75,\n\n  // 61.75px\n  5x: $font-size-base * 5,\n  // 65px\n  5qx: $font-size-base * 5.25,\n  // 68.25px\n  5hx: $font-size-base * 5.5,\n  // 71.5px\n  5tx: $font-size-base * 5.75 // 74.75px\n  ) !default;\n\n\n$sizes: (\n  10: 10%,\n  20: 20%,\n  30: 30%,\n  40: 40%,\n  60: 60%,\n  70: 70%,\n  80: 80%,\n  90: 90%,\n);\n\n$body-color: $grayLight5;\n$body-bg: $grayLight1;\n\n$dropdown-padding-y: 0;\n$dropdown-item-padding-y: 8px;\n$dropdown-link-color: $grayDark;\n$dropdown-link-hover-bg: $primary;\n$dropdown-link-hover-color: #fff;\n\n$modal-backdrop-bg: #000;\n$modal-backdrop-opacity: 0.75;\n$modal-content-border-radius: 0;\n\n$btn-padding-y: 0.75rem;\n\n$label-margin-bottom: 0.2rem;\n$input-height: 2.5rem;\n\n$custom-file-height-inner: 100%;\n//$input-padding-y:1rem;\n\n$icomoon-font-path: \"/assets/fonts\";\n\n$nav-tabs-link-active-color: #ffffff;\n\n$nav-tabs-link-active-color: #ffffff;\n$nav-tabs-link-active-bg: $grayDark;\n$nav-tabs-link-active-border-color: $grayDark;\n\n$link-color: $primary;\n\n\n$custom-file-text: (\n  en: \"Procurar\",\n  es: \"Procurar\"\n);\n\n.custom-file-label::after {\n  content: \"Procurar\" !important;\n}\n\n\n// Gradient\n.bg-gradient {\n  background: linear-gradient(178.18deg, $primary 44.62%, #9ad1e5 158.3%);\n  color: #fff !important;\n}\n\n.bg-gradient-green {\n  background: linear-gradient(178.18deg, $green 44.62%, #9ad1e5 158.3%);\n  color: #fff !important;\n}\n\n.border-radius-215 {\n  border-radius: 215px;\n}\n\n.modal-extra {\n  max-width: 1900px;\n}\n\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n.cursor-no-drop {\n  cursor: no-drop !important;\n}\n\n.text-underline-hover {\n  &:hover {\n    text-decoration: 1px solid $primary;\n  }\n}\n\n.circle {\n  border-radius: 95px !important;\n}\n\n.font-raleway {\n  font-family: \"Raleway\", sans-serif !important;\n}\n\n@for $i from 1 through 9 {\n  .font-weight-#{$i}00 {\n    font-weight: $i * 100 !important;\n  }\n}\n\n@for $i from 1 through 9 {\n  .border-radius-#{$i}0 {\n    border-radius: $i * 10 !important;\n  }\n}\n\n.list-style-none {\n  list-style: none !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.bg-inherit {\n  background: inherit !important;\n}\n\n.linha-carrega-mais {\n  position: relative;\n  list-style: none;\n\n  li {\n    text-align: center;\n    background: $grayLight;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0 1rem;\n\n    span {\n      background: inherit;\n      z-index: 2;\n      padding-right: 10px;\n      padding-left: 10px;\n      position: absolute;\n      top: 0;\n      cursor: pointer;\n      margin: 0 -15px;\n\n      &:hover {\n        border-bottom: $primary solid 1px;\n        color: $primary;\n      }\n    }\n\n    &:after {\n      content: \"\";\n      width: 100%;\n      position: absolute;\n      background: rgba(0, 0, 0, 0.1);\n      height: 1px;\n      right: 0;\n      top: 13px;\n      z-index: 1;\n    }\n  }\n}\n\nngb-tabset {\n\n  .tabset,\n  .tab-content,\n  .tab-pane,\n  .tabbable {\n    height: 100% !important;\n  }\n}\n\n.white-space-nowrap {\n  white-space: nowrap !important;\n}\n\n.subModalOpen {\n  // Kill the scroll on the body\n  overflow: hidden !important;\n\n  .subModal {\n    overflow-x: hidden !important;\n    overflow-y: auto !important;\n  }\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.form-floating {\n  position: relative;\n  padding-top: 12px;\n  width: 100%;\n\n  label {\n    pointer-events: none;\n    position: absolute;\n    top: calc(60% - 8px);\n    left: 8px;\n    transition: all 0.1s linear;\n    -webkit-transition: all 0.1s linear;\n    -moz-transition: all 0.1s linear;\n    padding: 0rem 0.2rem;\n    box-sizing: border-box;\n    font-size: 12px;\n    white-space: nowrap;\n  }\n\n  input {\n    color: $primary;\n    border: 1px solid lightgrey;\n    border-radius: 5px;\n    outline: none;\n    // width: 600px;\n    width: 100%;\n    height: 2.8rem;\n    padding: 1.375rem 0.75rem 0.75rem 0.75rem;\n    font-size: 16px;\n    transition: all 0.1s linear;\n    -webkit-transition: all 0.1s linear;\n    -moz-transition: all 0.1s linear;\n    -webkit-appearance: none;\n\n    &:focus {\n      border: 1px solid $primary;\n\n      +label {\n        font-size: 10px;\n        top: 12px;\n        color: #2e6fea;\n      }\n    }\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:required {\n      &:invalid {\n        border: 1px solid $error;\n\n        +label {\n          color: $error;\n\n          &:before {\n            content: \"* \";\n          }\n        }\n      }\n    }\n\n    &:not(:placeholder-shown) {\n      +label {\n        font-size: 10px;\n        top: 12px;\n        color: #2e6fea;\n      }\n    }\n  }\n}\n\n.mobile-opcoes {\n  display: none;\n}\n\n:host ::ng-deep .popover {\n  max-width: fit-content;\n  // box-shadow: 3px 3px 5px $grayLight;\n\n  .arrow {\n    &::after {\n      border-bottom-color: $grayLight4;\n    }\n  }\n\n  .popover-header {\n    background-color: $primary;\n    padding: 0.5rem 0.75rem;\n    color: #fff;\n    text-align: center;\n    text-transform: uppercase;\n    font-weight: bold;\n    font-size: 14px;\n\n    &::before {\n      border-bottom: none;\n    }\n  }\n\n  .popover-body {\n    padding: 0;\n\n    button {\n      &:hover {\n        background-color: $primary;\n        color: #fff !important;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
